import React from 'react';
import styles from './errorPage.module.scss';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FancyButton } from '../primitives/FancyButton';
import { useNavigate } from 'react-router-dom';
import { DEV_MODE } from '../miscUtils';
import { useApiContext } from '../../api';

interface ErrorPageProps {
  error: Error;
  title?: string;
  description?: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ error, title, description }) => {
  const { logout } = useApiContext();
  title = title ?? 'Oops...Something went wrong';

  const returnButton = () => {
    return (
      <FancyButton
        iconName="house"
        onClick={() => {
          navigate('/');
          window.location.reload();
        }}
      >
        Return to Start page
      </FancyButton>
    );
  };

  const logoutButton = () => {
    return (
      <FancyButton
        iconName="user"
        onClick={() => {
          logout(true);
        }}
      >
        Logout
      </FancyButton>
    );
  };

  const navigate = useNavigate();
  return DEV_MODE ? (
    <div className={styles.devErrorWrapper}>
      <div>
        <h1>
          {error.name} : {error.message}
        </h1>
      </div>
      <div className={styles.tracebackWrapper}>
        {error.stack?.split('\n').map((line, index) => {
          if (index > 0) {
            return <div key={index}>{line}</div>;
          }
        })}
      </div>
      <div>
        {returnButton()} {logoutButton()}
      </div>
    </div>
  ) : (
    <div className={styles.errorWrapper}>
      <div>
        <h1 style={{ textAlign: 'center' }}>{title}</h1>
        {description && <div>{description}</div>}
      </div>
      <div className={styles.iconWrapper}>
        <FontAwesomeIcon icon="fa-solid fa-dna" flip className={styles.slowSpin} />
      </div>
      <div>{returnButton()}</div>
    </div>
  );
};

export const ErrorPageNotFound = withAuthenticationRequired(() => {
  return (
    <ErrorPage
      error={new Error('Page not found')}
      title="Page not found"
      description="We couldn't find the page you were looking for."
    />
  );
});
